/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLockAlt} from '@fortawesome/pro-duotone-svg-icons';

const SecurityIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faLockAlt} {...props} />
);

export default SecurityIcon;
